<script setup lang="ts">
import { computed } from 'vue';
import type { ActivityMethodName, ActivityTypeName } from '@apparatix/schemas/Activities';
import { useActivities, useUtilities } from '@apparatix/composables';

type Props = {
  method?: ActivityMethodName;
  type?: ActivityTypeName;
}

const props = defineProps<Props>();

const { getIconForActivityType, getIconForMethod } = useActivities();
const { developerWarning } = useUtilities();

const icon = computed(() => {
  developerWarning(
    () => !props.method && !props.type,
    'Expected either prop `method` or prop `type` to be set, but both are undefined',
    'console:warn',
  );

  developerWarning(
    () => Boolean(props.method) && Boolean(props.type),
    'Only props `method` OR `type` should be provided, not both',
    'console:warn',
  );

  return props.method
    ? getIconForMethod(props.method)
    : getIconForActivityType(props.type);
});
</script>
<template>
  <div class="flex items-center justify-center w-[42px] h-[42px] rounded-full bg-[#E2E8F0]">
    <span style="font-size: 1.3rem;" :class="icon" />
  </div>
</template>
